import { useContext } from 'react';
import { PaymentContext } from '../context/payment-context';

export const usePayment = () => {
  const payment = useContext(PaymentContext);

  return payment;
};
